import React from "react";
import "../../../styles/components/onboarding/info/welcome-page.scss";
import { logosImages, onboardingImagesSource } from "../../../config/config";
import { WhenDeviceTypeDesktop } from "../../conditional/device/type/WhenDeviceTypeDesktop";
import { DynamicImage } from "components/common/DynamicImage";

export default function WelcomePage() {
  return (
    <div className="welcome-page">
      <WhenDeviceTypeDesktop>
        <DynamicImage
          webpSrc={onboardingImagesSource.playgroundPeopleLgWEBP2x}
          pngSrc={onboardingImagesSource.playgroundPeopleLgPNG2x}
          width={512}
          height={442}
          additionalClassName={"slide-image"}
          alt={
            "Separate images of an adult woman, older man, and young boy playing keyboard"
          }
        />
      </WhenDeviceTypeDesktop>
      <WhenDeviceTypeDesktop not>
        <header className="top">
          <img
            className="logo"
            src={logosImages.pgsWhite}
            alt="Playground Sessions"
            width={"50"}
          />
          <DynamicImage
            webpSrc={onboardingImagesSource.playgroundPeopleSmWEBP2x}
            pngSrc={onboardingImagesSource.playgroundPeopleSmPNG2x}
            width={333}
            height={316}
            additionalClassName={"playground-people-image"}
            alt={
              "Separate images of an adult woman, older man, and young boy playing keyboard"
            }
          />
        </header>
      </WhenDeviceTypeDesktop>

      <div className="content">
        <div className="content-header">
          Welcome to Playground&nbsp;Sessions
        </div>
        <div className="info-text">
          Thanks for joining us on your piano journey. We will be here for you
          every step of the way, from your first key, to your next big
          performance.
        </div>
      </div>
    </div>
  );
}
